import { motion } from "framer-motion";

/**
 * Keyword strip — a slim, editorial pill-cloud of every search term audiences
 * use to find COLAB Theatre. Doubles as inline SEO signal and a design flourish.
 */
const CHIPS = [
  "Best Immersive Theatre London",
  "Best Immersive Theatre",
  "Immersive Theatre London",
  "The Pinnacle of Immersive",
  "Immersive Experiences London",
  "Immersive Escape Theatre",
  "Immersive Horror London",
  "Immersive Spy Thriller",
  "Immersive Crime Drama",
  "Immersive Drag Panto",
  "Interactive Shakespeare London",
  "Immersive Western",
  "Immersive Heist Experience",
  "COLAB Tower",
  "COLAB Factory",
  "COLAB Tavern",
  "Best Night Out in London",
  "Immersive Escape Room London",
  "Best Panto in London",
  "Immersive Theatre Reviews",
  "5-Star Immersive Theatre",
  "Best London Theatre Experience",
  "Immersive Theatre near me",
  "London Escape Theatre",
  "Best Immersive Shows 2026",
];

export default function KeywordStrip() {
  return (
    <section
      id="keywords"
      data-testid="home-keywords"
      className="section relative bg-[#050505] border-t border-white/10"
    >
      <div className="px-6 md:px-14 lg:px-20 xl:px-24 mb-16 md:mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
        <div className="md:col-span-8">
          <div className="text-[10px] uppercase tracking-[0.35em] font-mono text-[#8b0000] mb-6">
            Best Immersive Theatre London · Search Terms
          </div>
          <h2 className="bleed-h max-w-4xl text-white">
            Best. Immersive. Theatre.
            <span className="block text-white/40">Reviews. London.</span>
          </h2>
        </div>
        <div className="md:col-span-4 text-white/60 text-sm md:text-base leading-relaxed">
          COLAB Theatre is what London searches for when it looks for the best
          immersive theatre reviews — genre by genre, venue by venue, year
          after year.
        </div>
      </div>

      <div className="px-6 md:px-14 lg:px-20 xl:px-24">
        <ul
          className="flex flex-wrap gap-2 md:gap-3"
          data-testid="keyword-chips"
        >
          {CHIPS.map((chip, i) => (
            <motion.li
              key={chip}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{
                duration: 0.5,
                delay: (i % 12) * 0.03,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="border border-white/15 px-4 py-2 text-[11px] uppercase tracking-[0.2em] font-mono text-white/70 hover:text-white hover:border-[#8b0000] hover:bg-[#8b0000] transition-colors duration-300"
            >
              {chip}
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
